import { useBudouX } from "@/hooks/useBudouX";

export const Interviewee = ({ children, speaker }) => {
  const { parse } = useBudouX();
  return (
    <>
      <dl className="flex gap-2 px-6 md:gap-4  md:px-0 lg:gap-6">
        {speaker && (
          <dt className="leading-loose text-icn fluid-text-[14px,18px]">
            {speaker}
          </dt>
        )}
        <dd className="fluid-text-[14px,18px]">{children}</dd>
      </dl>
    </>
  );
};

export const Interviewer = ({ children }) => {
  const { parse } = useBudouX();
  return (
    <>
      <p className="px-8 font-bold text-icn fluid-text-[11px,16px] md:px-0">
        ──&nbsp;{parse(`${children}`)}
      </p>
    </>
  );
};
